import React from 'react';
import dayjs from 'dayjs';
import { DatePicker, Input } from '@keen.io/ui-core';
import { TYPES_CONFIG } from '../../constants';
import FilterListValue from '../FilterListValue';
import FilterBoolean from '../FilterBoolean';
import GeoCoordinates from '../GeoCoordinates';
import { FilterString } from '../FilterString';
import { DatePickerContainer } from './FilterValue.styles';
export var getValueComponent = function getValueComponent(_ref) {
  var propertyType = _ref.propertyType,
      operator = _ref.operator,
      _onChange = _ref.onChange,
      value = _ref.value,
      id = _ref.id,
      stringPlaceholder = _ref.stringPlaceholder,
      suggestions = _ref.suggestions,
      suggestionsLoading = _ref.suggestionsLoading,
      suggestionsVisible = _ref.suggestionsVisible;
  var component = TYPES_CONFIG[propertyType][operator].component;

  switch (component) {
    case 'null-placeholder':
      return null;

    case 'list':
      return React.createElement(FilterListValue, {
        items: value,
        propertyType: propertyType,
        onChange: _onChange
      });

    case 'datepicker':
      return React.createElement(DatePickerContainer, null, React.createElement(DatePicker, {
        date: new Date(value.substring(0, 19)),
        id: "datepicker_".concat(id),
        onChange: function onChange(date) {
          return _onChange("".concat(dayjs(date.toString()).format('YYYY-MM-DDTHH:mm:ss'), "Z"));
        }
      }));

    case 'boolean-switcher':
      return React.createElement(FilterBoolean, {
        value: value,
        onChange: _onChange
      });

    case 'geo-coordinates':
      return React.createElement(GeoCoordinates, {
        onChange: _onChange,
        value: value
      });

    case 'input-number':
      return React.createElement(Input, {
        type: "number",
        variant: "solid",
        value: value,
        onChange: function onChange(e) {
          var value = e.currentTarget.value ? parseFloat(e.currentTarget.value) : '';

          _onChange(value);
        }
      });

    default:
      return React.createElement(FilterString, {
        onChange: _onChange,
        value: value,
        suggestions: suggestions,
        suggestionsVisible: suggestionsVisible,
        suggestionsLoading: suggestionsLoading,
        stringPlaceholder: stringPlaceholder
      });
  }
};